import io from 'socket.io-client';

type SocketInstance = ReturnType<typeof io>;

let socket: SocketInstance | null = null;

export function getSocket(): SocketInstance {
  if (!socket) {
    const url =
      process.env.NODE_ENV === 'production'
        ? window.location.origin
        : (process.env.REACT_APP_API_URL || window.location.origin);

    socket = io(url, {
      path: '/socket.io',
      transports: ['websocket', 'polling'],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
    });

    socket.on('connect', () => {
      console.log('[Socket] Connected:', socket?.id);
    });

    socket.on('disconnect', (reason: string) => {
      console.log('[Socket] Disconnected:', reason);
    });

    socket.on('connect_error', () => {
      if (socket && !socket.connected) {
        console.warn('[Socket] Connection failed. Ensure server is running.');
      }
    });
  }

  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
